module.exports = __webpack_public_path__ + "static/media/logo_en.f59c9097.svg";